function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.40819 3.862C9.60419 4.04933 9.91286 4.046 10.1042 3.85333C10.3015 3.65466 10.2989 3.33133 10.0969 3.13666L8.43819 1.53C8.17819 1.268 7.75686 1.268 7.49619 1.53L5.89619 3.13933C5.69486 3.342 5.70286 3.674 5.91486 3.86733C6.11219 4.04666 6.41486 4.03866 6.60286 3.85L7.50019 2.94666V10.8333C7.50019 11.1093 7.72419 11.3333 8.00019 11.3333C8.27619 11.3333 8.50019 11.1093 8.50019 10.8333V2.99L9.40819 3.862ZM3.66699 13.6667H12.3337V6.33336H10.667V5.33336H12.667C13.035 5.33336 13.3337 5.63203 13.3337 6.00003V14C13.3337 14.368 13.035 14.6667 12.667 14.6667H3.33366C2.96566 14.6667 2.66699 14.368 2.66699 14V6.00003C2.66699 5.63203 2.96566 5.33336 3.33366 5.33336H5.33366V6.33336H3.66699V13.6667Z",
  fill: "currentColor"
});

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.d3660b56.svg";
export { ForwardRef as ReactComponent };